import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CabecalhoPadrao from "../components/CabecalhoPadrao/CabecalhoPadrao";
import Carregamento from "../components/Carregamento/Carregamento";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FiltroPadrao from "../components/FiltroPadrao/FiltroPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import TabelaPadrao from "../components/TabelaPadrao/TabelaPadrao";
import { useCliente } from "../hooks/DropdownHooks";
import FiltroURLWrapper from "../hooks/FiltroUrlHook";
import api from '../services/api';
import { APP_ROUTES, getEditarPath } from "../services/app_routes";
import FiltroUtils from '../utils/FiltroUtils';
import { BREAKPOINTS_PADRAO, COLUNA_SITUACAO, criarColuna, criarColunaDesc, criarColunaHash, definirColunasFixas, OPCOES_SITUACAO } from "../utils/ListagemUtils";
import Mensagens from "../utils/MensagemUtils";
import PAGINATION from "../utils/PaginacaoUtils";
import { PERMISSOES } from "../utils/PermissaoUtils";

export default function ListagemChaves() {

    const navigate = useNavigate();
    const [chaves, setChaves] = useState([]);
    const [totalChaves, setTotalChaves] = useState(0);
    const [carregando, setCarregando] = useState(false);
    const [buscaInicial, setBuscaInicial] = useState(true);


    const filtrarRef = useRef(null);
    const currentPageRef = useRef(-1);
    const { itens: clientesFk, carregando: carregandoclientes } = useCliente();

    const carregamentoGeral = () => carregando || carregandoclientes;

    const colunasFixas = definirColunasFixas();

    import_fallback_useEffect: {
        React.useEffect(() => {
            if (filtrarRef.current) filtrarRef.current(0);
        }, []);
    }

    const filtrosChave = {
        unidade: "",
        descricao: "",
        razaoSocialCliente: "",
        situacaoCadastro: "",
    };

    const colunas = [
        criarColunaDesc("Descrição", 'descricao'),
        criarColunaHash("Hash da Chave", 'hashKey'),
        criarColuna("Unidade", 'sistemaDTO.unidade'),
        criarColuna("Diário", 'limiteDiario'),
        criarColuna("Semanal", 'limiteSemanal'),
        criarColuna("Mensal", 'limiteMensal'),
        COLUNA_SITUACAO(obj => obj.situacaoCadastro),

    ];

    return <>
        <FiltroURLWrapper
            defaultFilters={filtrosChave}
            defaultPage={PAGINATION.DEFAULT_FIRST_PAGE}
            defaultSize={PAGINATION.DEFAULT_PAGE_SIZE}
            basePath={APP_ROUTES.DESENVOLVIMENTO_CHAVES}
        >
            {({
                currentPage,
                pageSize,
                filtros,
                setFiltros,
                aplicarFiltros,
                limparFiltros,
                proximaPagina,
                paginaAnterior,
                irParaPagina,
            }) => {

                const fetchChaves = async (queryString) => {
                    setCarregando(true);
                    try {
                        const apiResponse = await api.get(`/apiKey_${queryString}`);
                        if (apiResponse.success) {
                            const { content, page } = apiResponse.data;
                            setChaves(content);
                            setTotalChaves(page.totalElements);
                        } else {
                            setChaves([]);
                            setTotalChaves(0);
                        }
                    } catch (e) {
                        setChaves([]);
                        setTotalChaves(0);
                    } finally {
                        setCarregando(false);
                    }
                };


                const filtrar = async (page = 0, isBuscaManual = false) => {
                    if (!isBuscaManual && buscaInicial && !filtros.situacaoCadastro) {
                        const filtrosComSituacao = { ...filtros, situacaoCadastro: 'ATIVO' };
                        setFiltros(filtrosComSituacao);
                        setBuscaInicial(false);

                        const filtrosSanitizados = { ...filtrosComSituacao };
                        const queryString = FiltroUtils.applyPageFilter(page, pageSize, filtrosSanitizados);
                        await fetchChaves(queryString);
                    } else {
                        aplicarFiltros(page);
                        const filtrosSanitizados = { ...filtros };
                        const queryString = FiltroUtils.applyPageFilter(page, pageSize, filtrosSanitizados);
                        await fetchChaves(queryString);
                    }
                };


                if (filtrarRef.current !== filtrar) {
                    filtrarRef.current = filtrar;
                }

                if (currentPageRef.current !== currentPage) {
                    currentPageRef.current = currentPage;
                    filtrar(currentPage);
                }

                // Sempre que pesquisar, volta para página 0 e filtra
                const pesquisar = async () => {
                    setBuscaInicial(false); // Evita chamadas assincronas subsequentes
                    irParaPagina(0);
                    await filtrar(0, true); // Interrompe sincronamente que ele injete ATIVO
                };

                // Função customizada para limpar filtros
                const limparFiltrosCustom = () => {
                    setBuscaInicial(false); // Marcar que não é mais busca inicial
                    limparFiltros();
                };

                const handleEditar = chaves => {
                    if (chaves.id) {
                        navigate(getEditarPath(APP_ROUTES.DESENVOLVIMENTO_CHAVES_EDITAR, chaves.id));
                    }
                };

                const handleCriarChave = () => {
                    navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES_CADASTRO);
                };

                return (<>
                    {carregamentoGeral() && <Carregamento />}

                    <CabecalhoPadrao
                        titulo={Mensagens.DESENVOLVIMENTO.CHAVES_DE_API}
                        textAdd={"Chave"}
                        permissao={PERMISSOES.APIKEY_CADASTRAR}
                        onClick={handleCriarChave}
                    />

                    <FiltroPadrao
                        filtrar={pesquisar}
                        limparFiltros={limparFiltrosCustom}
                    >
                        <InputPadrao
                            label={'Descrição'}
                            placeholder={'Procure pela descrição da chave'}
                            value={filtros.descricao || ""}
                            name="descrição"
                            onChange={e => setFiltros({ ...filtros, descricao: e.target.value })}
                        />

                        <DropdownPadrao
                            label={'Cliente'}
                            showFilter={true}
                            options={clientesFk?.map(c => ({ value: c.label, label: c.label })) || []}
                            value={filtros.razaoSocialCliente || ""}
                            name="razaoSocialCliente"
                            onChange={e => setFiltros({ ...filtros, razaoSocialCliente: e.target.value })}
                        />

                        <InputPadrao
                            label={'Unidade'}
                            placeholder={'Procure pela unidade da chave'}
                            value={filtros.unidade}
                            name="unidade"
                            onChange={e => setFiltros({ ...filtros, unidade: e.target.value })}
                        />

                        <DropdownPadrao
                            label={'Situação Cadastro'}
                            showFilter={true}
                            options={OPCOES_SITUACAO}
                            value={filtros.situacaoCadastro}
                            name="situacaoCadastro"
                            onChange={e => setFiltros({ ...filtros, situacaoCadastro: e.target.value })}
                        />
                    </FiltroPadrao>
                    <TabelaPadrao
                        dados={chaves}
                        colunas={colunas}
                        totalItems={totalChaves}
                        paginaAtual={currentPage}
                        tamanhoPagina={pageSize}
                        carregando={carregando}
                        onEditar={handleEditar}
                        onProximaPagina={proximaPagina}
                        onPaginaAnterior={paginaAnterior}
                        onIrParaPagina={irParaPagina}
                        colunasFixas={colunasFixas}
                        breakpoints={BREAKPOINTS_PADRAO}
                        permissaoEditar={PERMISSOES.APIKEY_EDITAR}
                        gruposColunas={[{ titulo: 'Limite de Requisição', indices: [3, 4, 5] }]}
                    />
                </>)
            }}

        </FiltroURLWrapper>
    </>
} 